import { ICreateClaimRequest } from "common/interfaces/apiRequest/ICreateClaimRequest";
import { IInvoiceLineItemsSearchRequest } from "common/interfaces/apiRequest/IInvoiceLineItemsSearchRequest";
import { IInvoiceSearchRequest } from "common/interfaces/apiRequest/IInvoiceSearchRequest";
import { IClaimLineItem } from "common/interfaces/IClaimLineItem";
import { IUser } from "common/interfaces/IUser";
import { TemplateRestService } from "infrastructure/rest/TemplateRestService";


const CLAIM_BASE = "/Claim";
const secureClaimRestService = new TemplateRestService(true, CLAIM_BASE);

export class ClaimApi {
    public static async getCutomers(): Promise<any> {
        const response = await secureClaimRestService.get(`/customers`);
        return response.data;
    }

    public static async getClaims(): Promise<any> {
        const response = await secureClaimRestService.get("");
        return response.data;
    }

    public static async getPaginatedClaims(page: number, pageSize: number, searchText: string, customer: string, status: number, claimFilter: number): Promise<any> {
        const response = await secureClaimRestService.post(`/searchClaims`, { page: page,pageSize: pageSize, searchText: searchText, customer: customer, status: status,claimFilter: claimFilter });
        return response.data;
    }

    public static async getClaimById(claimId: number): Promise<any> {
        const response = await secureClaimRestService.get(`/${claimId}`);
        return response.data;
    }

    public static async getAttachementsByClaimId(claimId: number): Promise<any> {
        const response = await secureClaimRestService.get(`/getAttachments/${claimId}`);
        return response.data;
    }

    public static async getAttachementByClaimAttachmentId(claimAttachmentId: number): Promise<any> {
        const response = await secureClaimRestService.getFile(`/attachment/${claimAttachmentId}`);
        return response;
    }

    public static async removeAttachementByClaimAttachmentId(claimAttachmentId: number): Promise<any> {
        const response = await secureClaimRestService.delete(`/attachment/${claimAttachmentId}`);
        return response.data;
    }

    public static async submitClaim(claimId: number, products: IClaimLineItem[] ): Promise<any> {
        const response = await secureClaimRestService.post(`/submit`, { claimId: claimId, products: products });
        return response.data;
    }

    public static async saveComment(claimId: number,notifyUsers: IUser[], comment: string): Promise<any> {
        const response = await secureClaimRestService.post(`/comment`, { claimId: claimId, users: notifyUsers, comment: comment });
        return response.data;
    }

    public static async getCommentsByClaimId(claimId: number): Promise<any> {
        const response = await secureClaimRestService.get(`/comments/${claimId}`);
        return response.data;
    }

    public static async updateClaimStatusWithComment(updateRequest: any): Promise<any> {
        const response = await secureClaimRestService.post(`/updateclaimstatuscomments`, updateRequest);
        return response.data;
    }

    public static async updateClaimAccountManager(claimId: number, accountManagerId: number, debitNoteNumber : string): Promise<any> {
        const response = await secureClaimRestService.post(`/updateclaimaccountmanager`, { claimId: claimId, accountManagerId: accountManagerId, debitNoteNumber: debitNoteNumber });
        return response.data;
    }


    public static async getClaimAuditById(claimId: number): Promise<any> {
        const response = await secureClaimRestService.get(`/audit/${claimId}`);
        return response.data;
    }

    public static async getClaimCreditReasonCodes(): Promise<any> {
        const response = await secureClaimRestService.get(`/reasoncodes`);
        return response.data;
    }

    public static async getOutstandingClaims(): Promise<any> {
        const response = await secureClaimRestService.get(`/outstanding`);
        return response.data;
    }

    public static async getClaimWorkflow(claimId: number): Promise<any> {
        const response = await secureClaimRestService.get(`/claimworkflow/${claimId}`);
        return response.data;
    }

    public static async searchInvoice(invoiceSearchRequest: IInvoiceSearchRequest): Promise<any> {
        const response = await secureClaimRestService.post(`/searchinvoice`, invoiceSearchRequest);
        return response.data;
    }

    public static async searchInvoiceItems(invoiceSearchRequest: IInvoiceLineItemsSearchRequest): Promise<any> {
        const response = await secureClaimRestService.post(`/searchinvoiceitems`, invoiceSearchRequest);
        return response.data;
    }

    public static async createClaim(createClaimRequest: ICreateClaimRequest): Promise<any> {
        const response = await secureClaimRestService.post(`/create`, createClaimRequest);
        return response.data;
    }

    public static async saveClaimProducts(products: IClaimLineItem[]): Promise<any> {
        const response = await secureClaimRestService.post(`/products`, { products: products });
        return response.data;
    }
}
